module.exports = __webpack_public_path__ + "src/img/peEditOn.109f0fff.svg";